import React from 'react';
import { Box, Container } from '@chakra-ui/react';
import Header from './Header';

const PageLayout = ({ children, containerSize = '6xl', centerContent = false }) => {
  return (
    <Container maxW="100%" fluid={true}>
    
      <Header />
      <Box as="main">
        <Container maxW={containerSize} centerContent={centerContent}>
          {children}
        </Container>
      </Box>

    </Container>
  );
};

export default PageLayout; 